import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";

export const ButtonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: grid;
    margin-bottom: ${theme.spacings.lg};
    margin-top: ${theme.spacings.lg};

    > div {
      justify-self: center;
    }
  `}
`;

export const MoreInvolvedButton = styled.button<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    background-color: white;
    color: ${theme.colors.primary};
    padding: ${theme.spacings.md} 0;
    border: none;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    column-gap: ${theme.spacings.xs};
  `}
`;
